import {createApp} from 'vue'
import {createRouter, createWebHistory} from 'vue-router';
import App from './App.vue'
import Mixin from './mixin.js'
import Home from './page/Home.vue'
import About from './page/About.vue'
import "./scss/index.scss";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);


const routes = [
    {path: '/', name: 'Home', component: Home},
    {path: '/about', component: About},
]

const scrollBehavior = (to, from, savedPosition) => {
    if (savedPosition) {
        return savedPosition;
    } else {
        return {top: 0}
    }
};

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior
})

createApp(App).mixin(Mixin).use(router).mount('#app')


const spanWrapText = (target) => {
    const nodes = [...target.childNodes];
    let returnText = '';
    for (const node of nodes) {
        if (node.nodeType === 3) {
            const text = node.textContent.replace(/\r?\n/g, '');
            returnText += text.split('').reduce((acc, v) => {
                return acc + `<span>${v}</span>`
            }, "");
        } else {
            returnText = returnText + node.outerHTML
        }
    }
    return returnText;
}

const inViewImage = document.querySelectorAll(".js-inViewImage")
for (const target of inViewImage) {
    gsap.to(target, {
        scrollTrigger: {
            trigger: target,
            start: "top 55%",
        },
        onStart: () => {
            target.classList.add('in-view')
        },
    });
}

const inViewImage2 = document.querySelectorAll(".js-inViewImage2")
for (const target of inViewImage) {
    gsap.to(target, {
        scrollTrigger: {
            trigger: target,
            start: "top 80%",
        },
        onStart: () => {
            target.classList.add('in-view')
        },
    });
}

const fadeInUp = document.querySelectorAll(".js-fadeInUp")
for (const target of fadeInUp) {
    gsap.from(target, {
        scrollTrigger: {
            trigger: target,
            start: "top 70%",
        },
        duration: 1,
        ease: "power2.out",
        opacity: 0,
        y: 30,
    });
}
const staggerText = document.querySelectorAll(".js-staggerText")
for (const target of staggerText) {
    target.innerHTML = spanWrapText(target)
    gsap.from(target.childNodes, {
        scrollTrigger: {
            trigger: target,
            start: "top 70%",
        },
        stagger: 0.05,
        duration: 0.5,
        ease: "power2.out",
        opacity: 0,
    })
}

const fadeInUpStagger = document.querySelectorAll(".js-fadeInUpStagger")
for (const target of fadeInUpStagger) {
    gsap.from(target.children, {
        scrollTrigger: {
            trigger: target,
            start: "top 70%",
        },
        stagger: 0.1,
        duration: 1,
        ease: "power2.out",
        opacity: 0,
        y: 30,
    });
}

